import { Grid, Image, Message } from 'semantic-ui-react';
// import screenImage from '../../images/screen.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GridNumbers } from '../../utils';
import { oneOfType, node, string, arrayOf, bool } from 'prop-types';
import { StyledGrid } from './SearchResultsPlaceholder.style';
import uuidv4 from 'uuid';

// Note: images expects an array of images to render.

const SearchResultsPlaceholder = props => {
  const { images = [], header, error, children } = props;

  // no matter what server errors we receive, always show this message specified at AGIDS-290
  return error ? (
    <Message
      error
      visible
      icon="exclamation circle"
      content={
        <FormattedMessage
          id="error.server"
          defaultMessage="We have encountered an error. Please refresh the page and try again. If the error persists, you can use our {link} to inform us and we will address it as soon as possible."
          values={{
            link: (
              <a
                onClick={() => {
                  if (!window.zE) {
                    return;
                  }
                  window.zE.activate();
                }}
              >
                <FormattedMessage
                  id="cta.feedback_form"
                  defaultMessage="website feedback form"
                />
              </a>
            )
          }}
        />
      }
    />
  ) : (
    <StyledGrid data-testid="results-placeholder-component">
      <Grid.Column mobile={GridNumbers.base} computer={GridNumbers.half}>
        {images && images.length > 0 && (
          <ul
            className="searchresultsplaceholder__images"
            data-testid="placeholder-image-list"
          >
            {images.map(image => (
              <li key={uuidv4()}>
                <Image src={image} aria-label={`An icon for ${image}`} />
              </li>
            ))}
          </ul>
        )}
        <article className="searchresultsplaceholder__content">
          {header && <h3 data-testid="placeholder-header">{header}</h3>}
          {children}
        </article>
      </Grid.Column>
    </StyledGrid>
  );
};

SearchResultsPlaceholder.propTypes = {
  images: arrayOf(string),
  header: oneOfType([node, string]),
  error: bool,
  children: oneOfType([node, string])
};

export default SearchResultsPlaceholder;



// WEBPACK FOOTER //
// ./src/components/SearchResultsPlaceholder/SearchResultsPlaceholder.js